import { Action } from '@ngrx/store';
import { UserInterface } from './users.model';
import {
  BaseOneResponseInterface,
  BulkResponseDataInterface,
  GetManyResponseInterface,
} from '../../../shared/model/interface/crud-response-interface.model';
import { TabRowInterface } from '../../../shared/component/side-config-bar/side-config-bar.model';

export const ADD_USER = '[USERS] ADD USER';
export const ADD_USER_COMPLETED = '[USERS] ADD USER COMPLETED';
export const EDIT_USER = '[USERS] EDIT USER';
export const EDIT_USER_COMPLETED = '[USERS] EDIT USER COMPLETED';
export const EDIT_CURRENT_USER = '[USERS] EDIT CURRENT USER';
export const EDIT_CURRENT_USER_COMPLETED = '[USERS] EDIT CURRENT USER COMPLETED';
export const GET_USER = '[USERS] GET USER';
export const GET_USER_COMPLETED = '[USERS] GET USER COMPLETED';
export const DELETE_USERS = '[USERS] DELETE USERS';
export const DELETE_USERS_COMPLETED = '[USERS] DELETE USERS COMPLETED';
export const USERS_DATA_LOADING = '[USERS] USERS ACTION DATA LOADING';
export const USERS_DATA_LOADED = '[USERS] USERS ACTION DATA LOADED';
export const USERS_FETCH_ERROR = '[USERS] FETCH USERS ERROR';
export const SET_TABLE_SETTINGS = '[USERS] USERS TABLE SETTINGS SET';


export class UsersDataLoading implements Action {
  readonly type = USERS_DATA_LOADING;

  constructor(public limit?: number) {}
}

export class UsersDataLoaded implements Action {
  readonly type = USERS_DATA_LOADED;

  constructor(public payload: GetManyResponseInterface<UserInterface>) {}
}

export class AddUser implements Action {
  readonly type = ADD_USER;
  constructor(public user: UserInterface) {}
}

export class AddUserCompleted implements Action {
  readonly type = ADD_USER_COMPLETED;
  constructor(public payload: UserInterface) {}
}

export class EditUser implements Action {
  readonly type = EDIT_USER;
  constructor(public user: UserInterface, public userId: number, public isSelf: boolean) {}
}

export class EditUserCompleted implements Action {
  readonly type = EDIT_USER_COMPLETED;
  constructor(public payload: BaseOneResponseInterface<UserInterface>) {}
}

export class EditCurrentUser implements Action {
  readonly type = EDIT_CURRENT_USER;
  constructor(public user: UserInterface, public userId: number) {}
}

export class EditCurrentUserCompleted implements Action {
  readonly type = EDIT_CURRENT_USER_COMPLETED;
}

export class DeleteUsers implements Action {
  readonly type = DELETE_USERS;
  constructor(public payload: number[]) {}
}

export class DeleteUsersCompleted implements Action {
  readonly type = DELETE_USERS_COMPLETED;
  constructor(public isBulk: boolean, public response: BulkResponseDataInterface) {}
}

export class GetUser implements Action {
  readonly type = GET_USER;
  constructor(public userId: number) {}
}

export class GetUserCompleted implements Action {
  readonly type = GET_USER_COMPLETED;
  constructor(public payload: BaseOneResponseInterface<UserInterface>) {}
}

export class SetTableSettings implements Action {
  readonly type = SET_TABLE_SETTINGS;
  constructor(public payload: TabRowInterface[], public setAsDefault: boolean) {}
}

export class FetchError implements Action {
  readonly type = USERS_FETCH_ERROR;

  constructor(public payload: object) {}
}

export type UserSettingsActions =
  | UsersDataLoading
  | UsersDataLoaded
  | AddUser
  | AddUserCompleted
  | EditUser
  | EditUserCompleted
  | EditCurrentUser
  | EditCurrentUserCompleted
  | GetUser
  | GetUserCompleted
  | DeleteUsers
  | DeleteUsersCompleted
  | SetTableSettings
  | FetchError;
